export enum FlightClassType {
  ANY = 'any',
  ANY_DEPRECATED = 'A',
  ECONOMY = 'Y',
  PREMIUM_ECONOMY = 'P',
  BUSINESS = 'C',
  FIRST_CLASS = 'F',
}
